import { apiFetch } from "./client";
import type { LoginOut } from "@/types/api";
import { buildLoginPayload, type LoginPayload } from "@/lib/auth-utils";

function getStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try { return localStorage; } catch { return sessionStorage; }
}

export async function login(identifier: string, password: string): Promise<LoginOut> {
  const payload: LoginPayload = buildLoginPayload(identifier, password);
  const data = await apiFetch<LoginOut>("/auth/login/", {
    method: "POST",
    body: JSON.stringify(payload),
  }, true);
  getStorage()?.setItem("token", data.token);
  return data;
}

export function logout(): void {
  getStorage()?.removeItem("token");
}
